import {
  Banner,
  stenaAnimals,
  stenaBusinessCard,
} from "@stenajs-webui/elements";

import { getTotalWeightFromGoodsItems } from "../../../../common/goods/goodsUtils";
import type { BasicBooking } from "../../../../common/graphql/fragments/gql/BasicBooking";
import { animalDropdownNoOption } from "../../../../common/graphql/useAnimalTypesOptions";
import { Information } from "../../../../common/texts";
import { useUpdateField } from "../../../../common/update-information/hooks/useUpdateField";
import { getHazardousGoodsBannerApprovalInfo } from "../utils/detailsUtils";
import { shouldShowHazGoodsPaymentInformation } from "../utils/showPaymentUtil";
import { BookingHazardousGoodsBanner } from "./BookingHazardousGoodsBanner";

interface BookingDetailsCargoBannersProps {
  booking: BasicBooking;
}

export const BookingDetailsCargoBanners = ({
  booking,
}: BookingDetailsCargoBannersProps) => {
  const { editedValue: goodsItems = {} } = useUpdateField("goods");
  const totalGoodsWeight = getTotalWeightFromGoodsItems(goodsItems);
  const hazardousGoodsWeight = booking.cargoWeight - totalGoodsWeight;
  const { editedValue: hazardousGoods } = useUpdateField("hazardousGoods");
  const { editedValue: livestock } = useUpdateField("livestockType");

  const hazardousGoodsApprovalInfo = getHazardousGoodsBannerApprovalInfo(
    Boolean(hazardousGoods),
    booking.hazardousGoodsApproved,
    booking.bookingStatus.status,
    hazardousGoodsWeight,
  );

  const showHazGoodsPaymentInformation =
    shouldShowHazGoodsPaymentInformation(booking);

  const hasLivestock = livestock?.value !== animalDropdownNoOption.value;

  return (
    <>
      {hazardousGoodsApprovalInfo && hazardousGoods && (
        <BookingHazardousGoodsBanner
          bookingNo={booking.bookingNo}
          hazardousGoodsApproved={booking.hazardousGoodsApproved}
          approvalInfo={hazardousGoodsApprovalInfo}
        />
      )}
      {showHazGoodsPaymentInformation && (
        <Banner
          icon={stenaBusinessCard}
          variant={"info"}
          text={Information.HazardousGoodsConfirmedPayableOnline}
        />
      )}
      {hasLivestock && (
        <Banner
          variant={"warning"}
          text={Information.AnimalsInformation}
          icon={stenaAnimals}
        />
      )}
    </>
  );
};
